export default __webpack_public_path__ + "static/media/br_01.b781cbba.jpg";